import { BaseComponent } from 'src/app/system-common/base/base.component';
import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HeaderService } from 'src/app/system-common/services/header.service';

export class DynamicKpiDetailsHandler extends BaseComponent<ContestAndIncentiveDetailsService> implements OnInit {
  constructor(service: ContestAndIncentiveDetailsService) {
    super(service);
  }
}
